import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { differenceInCalendarDays, format, parse } from "date-fns";
import { es } from "date-fns/locale";
import { differenceInDays } from "date-fns/esm/fp";

import moment from "moment";
import { toast } from "react-toastify";
import { FaBarcode, FaInfoCircle, FaSpinner } from "react-icons/fa";
import Modal from "../ui/Modal";

const ItemRowAfiliacionClientes = ({ client, setClients, setOpenModalServiciosCotizacionCliente, setCurrentClient, setCurrentClientCotizaciones, setOpenCotizacionesCliente, activeCols }) => {
  
  const [ultimaVentaServicio, setUltimaVentaServicio] = useState(null);
  const [daysUntilFechaAniversario, setDaysUntilFechaAniversario] = useState(null);
  const [daysUntilCumpGerente, setDaysUntilCumGerente] = useState(null);


  const [servicesModal, setServicesModal] = useState(false)
  const [cotsModal, setCotsModal] = useState(false)

  const [servicesLoading, setServicesLoading] = useState(false)
  const [cotsLoading, setCotsLoading] = useState(false)

  const [clientServices, setClientServices] = useState([])
  const [clientCots, setClientCots] = useState([])

  useEffect(() => {
    if (client?.fechaAniversario) {
      const fechaAniversario = moment(
        client.fechaAniversario,
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      const today = moment();
      fechaAniversario.year(today.year());
      // Si la fecha de cumpleaños ya pasó este año, calculamos para el próximo año
      if (
        today.isAfter(fechaAniversario) ||
        today.isSame(fechaAniversario, "day")
      ) {
        fechaAniversario.add(1, "year");
      }
      // Calcula los días restantes hasta el próximo cumpleaños
      const daysUntilFechaAniversario = fechaAniversario.diff(today, "days");
      setDaysUntilFechaAniversario(daysUntilFechaAniversario);
    }

    if (client?.cumpleaniosGerente) {
      const fechaCumGerente = moment(
        client.cumpleaniosGerente,
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      const today = moment();
      fechaCumGerente.year(today.year());
      // Si la fecha de cumpleaños ya pasó este año, calculamos para el próximo año
      if (
        today.isAfter(fechaCumGerente) ||
        today.isSame(fechaCumGerente, "day")
      ) {
        fechaCumGerente.add(1, "year");
      }
      // Calcula los días restantes hasta el próximo cumpleaños
      const daysUntilFechaAniversario = fechaCumGerente.diff(today, "days");
      setDaysUntilCumGerente(daysUntilFechaAniversario);
    }
  }, []);

  const copyToClipBoard = (id) => {
      navigator.clipboard.writeText(id).then(() => {
          toast.success("ID copiado al portapapeles")
      }).catch((err) => {
          toast.error("Error al copiar el ID: " + err);
      })
  }

  const getClientServices = async () => {
    try {
      setServicesLoading(true)
      const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones?where[cotizacion.cliente][equals]=${client.id}&limit=0`)
      const filteredServices = response.data.docs.filter((service) => service.cotizacion.estado === "Exito")
      setClientServices(filteredServices)
      //setClientServices(response.data.docs)

    } catch (e) {
      toast.error("Error al obtener los servicios del cliente: " + e)
    }  finally {
      setServicesLoading(false)
    }
  }

  const getClientCots = async () => {
    try {
      setCotsLoading(true)
      const response = await axios.get(`${BACKEND}/api/cotizaciones?where[cliente][equals]=${client.id}&[estado][equals]=exito&limit=0`)
      setClientCots(response.data.docs)

    } catch (e) {
      toast.error("Error al obtener las cotizaciones del cliente: " + e)
    }  finally {
      setCotsLoading(false)
    }
  }

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const handleUpdateText = (field, newValue, clientId) => { // Cambiar el texto con lógica de debouncer

    setClients((prevData) =>
      prevData.map((client) =>
        client.id === clientId
          ? {
              ...client,
              [field]: newValue,
            }
          : client
      )
    );

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {

        await axios.put(`${BACKEND}/api/clientesUser/${clientId}`, {
          [field]: newValue,
        });

        toast.success("Dato actualizado con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 1000); // Esperar 2 secs luego de que el usuario deja de ecsribir
  };

  const handleUpdateSelect = async (field, newValue, clientId) => { // Cambiar un selector, sin debouncer
    
    setClients((prevData) =>
      prevData.map((client) =>
        client.id === clientId
          ? {
              ...client,
              [field]: newValue,
            }
          : client
      )
    );

    try {
      await axios.put(`${BACKEND}/api/clientesUser/${clientId}`, {
        [field]: newValue,
      });
      toast.success("Dato actualizado con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar la fecha");
    }
  }

  return (
    <tr className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100">

      <Modal
        activeModal={servicesModal}
        title={`Servicios de ${client.nombreComercial}`}
        onClose={() => setServicesModal(false)}
        centered
      >
        <div className="flex-grow overflow-y-auto">
          {servicesLoading ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>Cargando, por favor espera...</span>
                  <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
            ) : (
              clientServices.length === 0 ? (
                <div className="flex w-full h-full text-gray-700 items-center justify-center">
                  <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                      <span>No hay registros</span>
                      <FaInfoCircle className="text-gray-500" />
                  </div>
                </div>
              ) : (
                <table className="w-full table-fixed">
                  <thead className="bg-white sticky top-0 z-50">
                    <tr className="w-full text-gray-700 text-center text-xs font-semibold">
                      <td className="w-[10%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>ID</span>
                      </td>
                      <td className="w-[30%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>Servicio</span>
                      </td>
                      <td className="w-[20%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>Estado</span>
                      </td>
                      <td className="w-[20%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>Monto</span>
                      </td>
                      <td className="w-[20%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>Fecha de creación</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {clientServices.map((serv) => (
                      <tr
                        key={client.id}
                        className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100`}
                      >
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          <div className="flex w-full items-center justify-center">
                            <button
                              onClick={() => copyToClipBoard(serv.id)}
                              className="flex justify-start gap-2 items-center p-2 rounded-md cursor-pointer bg-yellow-600 text-yellow-500 bg-opacity-10 hover:bg-opacity-20 hover:text-yellow-700 hover:border-yellow-400 transition duration-100"
                            >
                              <FaBarcode />
                            </button>
                          </div>
                        </td>
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          {serv.servicio?.name}
                        </td> 
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          {serv.estado}
                        </td>
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          {serv.monto}
                        </td>
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          {format(new Date(serv.createdAt), "dd/MM/yyyy", { locale: es })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )
            )
          }
        </div>
      </Modal>

      <Modal
        activeModal={cotsModal}
        title={`Cotizaciones en éxito de ${client.nombreComercial}`}
        onClose={() => setCotsModal(false)}
        centered
      >
      <div className="flex-grow overflow-y-auto">
          {cotsLoading ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>Cargando, por favor espera...</span>
                  <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
            ) : (
              clientCots.length === 0 ? (
                <div className="flex w-full h-full text-gray-700 items-center justify-center">
                  <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                      <span>No hay registros</span>
                      <FaInfoCircle className="text-gray-500" />
                  </div>
                </div>
              ) : (
                <table className="w-full table-fixed">
                  <thead className="bg-white sticky top-0 z-50">
                    <tr className="w-full text-gray-700 text-center text-xs font-semibold">
                      <td className="w-[10%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>ID</span>
                      </td>
                      <td className="w-[40%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>Vendedor</span>
                      </td>
                      <td className="w-[20%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>Monto total</span>
                      </td>
                      <td className="w-[30%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <span>Fecha de creación</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {clientCots.map((cot) => (
                      <tr
                        key={client.id}
                        className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100`}
                      >
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center hover:cursor-pointer transition-all duration-100"
                        >
                          <div className="flex w-full items-center justify-center">
                            <button
                              onClick={() => copyToClipBoard(cot.id)}
                              className="flex justify-start gap-2 items-center p-2 rounded-md cursor-pointer bg-yellow-600 text-yellow-500 bg-opacity-10 hover:bg-opacity-20 hover:text-yellow-700 hover:border-yellow-400 transition duration-100"
                            >
                              <FaBarcode />
                            </button>
                          </div>
                        </td>
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          {cot.cotizador?.name}
                        </td> 
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          {cot.precioTotal.toFixed(2)}
                        </td> 
                        <td 
                          scope="row" 
                          className="px-4 py-2 max-w-xs border border-gray-300 text-center transition-all duration-100"
                        >
                          {format(new Date(cot.createdAt), "dd/MM/yyyy", { locale: es })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )
            )
          }
        </div>
      </Modal>

      {activeCols.find((e) => e.id === 1)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {client.hasActiveService ?
            <span className="font-bold text-green-500">
              Activo
            </span>
            : 
            <span className="font-bold text-red-500">
              Inactivo
            </span>
          }
        </td>
      )}
      {activeCols.find((e) => e.id === 2)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          <button
            onClick={() => copyToClipBoard(client.id)}
            className="flex justify-start gap-2 items-center p-2 rounded-md cursor-pointer bg-yellow-600 text-yellow-500 bg-opacity-10 hover:bg-opacity-20 hover:text-yellow-700 hover:border-yellow-400 transition duration-100"
          >
            <FaBarcode />
          </button>
        </td>
      )}
      {activeCols.find((e) => e.id === 3)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 font-bold text-center">{client.razonSocial}</td>
      )}
      {activeCols.find((e) => e.id === 4)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          S/. {client.totalPayments.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </td>
      )}  
      {activeCols.find((e) => e.id === 5)?.show && (
        <td 
          scope="row" 
          className="px-2 py-2 border border-gray-300 text-center"
        >
          <input 
            type="text"
            value={client.productos}
            placeholder="Buzos, comida, maquinaria, etc"
            className="text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent pr-2"
            onChange={(e) => handleUpdateText("productos", e.target.value, client.id)}
          />
        </td>
      )}
      {activeCols.find((e) => e.id === 30)?.show && (
        <td 
          scope="row" 
          className="px-2 py-2 border border-gray-300 text-center"
        >
          <select 
            type="text"
            value={client.ticket}
            className="w-[10rem] text-xs text-gray-700 bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            onChange={(e) => handleUpdateSelect("ticket", e.target.value, client.id)}
          >
            <option value="Seleccionar">Seleccionar</option>
            <option value="Bajo: -S/.500">Bajo: -S/.500</option>
            <option value="Normal: S/.800 - S/.3000">Normal: S/.800 - S/.3000</option>
            <option value="Alto: +S/.5000">Alto: +S/.5000</option>
          </select>
        </td>
      )}
      {activeCols.find((e) => e.id === 6)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 truncate text-center">
          {format(new Date(client.createdAt), "dd MMMM, yyyy", { locale: es })}
        </td>
      )}
      {activeCols.find((e) => e.id === 7)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          <button
            onClick={() => {
              getClientServices()
              setServicesModal(true)
            }}
            type="button"
          >
            <span className="w-4 px-4 py-3 font-bold hover:underline transition-all duration-100">
              Ver mas
            </span>
          </button>
        </td>
      )}
      {activeCols.find((e) => e.id === 8)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          <button
            onClick={() => {
              getClientCots()
              setCotsModal(true)
            }}
            type="button"
          >
            <span className="w-4 px-4 py-3 font-bold hover:underline">
              Ver mas
            </span>
          </button>
        </td>
      )}
      {activeCols.find((e) => e.id === 9)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {format(new Date(client.lastSell), "dd MMMM, yyyy", {locale: es})}
        </td>        
      )}
      {activeCols.find((e) => e.id === 10)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">{client?.ruc}</td>
      )}
      {activeCols.find((e) => e.id === 11)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center font-bold">{client.nombreComercial}</td>
      )}
      {activeCols.find((e) => e.id === 12)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">{client?.pais}</td>
      )}
      {activeCols.find((e) => e.id === 13)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">{client?.direccion}</td>
      )}
      {activeCols.find((e) => e.id === 14)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {client?.fechaAniversario && format(new Date(client.fechaAniversario), "dd MMMM, yyyy", {locale: es})}
        </td>
      )}
      {activeCols.find((e) => e.id === 15)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {daysUntilFechaAniversario && (
            <span>{daysUntilFechaAniversario} días</span>
          )}
        </td>
      )}
      {activeCols.find((e) => e.id === 16)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {client?.nEmpleados && <span>{client?.nEmpleados}</span>}
        </td>
      )}
      {activeCols.find((e) => e.id === 17)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.nicho && <span>{client?.nicho?.rubro.name}</span>}
        </td>
      )}
      {activeCols.find((e) => e.id === 18)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.nicho?.name}
        </td>
      )}
      {activeCols.find((e) => e.id === 19)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {client?.ingresosAnuales && (
            <span>S/. {client?.ingresosAnuales}</span>
          )}
        </td>
      )}
      {activeCols.find((e) => e.id === 20)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.nombreGerente && <span> {client?.nombreGerente}</span>}
        </td>
      )}
      {activeCols.find((e) => e.id === 21)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {client?.cumpleaniosGerente &&
            format(new Date(client.cumpleaniosGerente), "dd MMMM, yyyy", {
              locale: es,
            })}
        </td>
      )}
      {activeCols.find((e) => e.id === 22)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {daysUntilCumpGerente && <span>{daysUntilCumpGerente}</span>}
        </td>
      )}
      {activeCols.find((e) => e.id === 23)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.telefonoGerente && <span>{client?.telefonoGerente}</span>}
        </td>
      )}
      {activeCols.find((e) => e.id === 24)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.emailGerencia && <span>{client?.emailGerencia}</span>}
        </td>
      )}
      {activeCols.find((e) => e.id === 25)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.encargadoProyecto && (
            <span>{client?.encargadoProyecto}</span>
          )}
        </td>
      )}
      {activeCols.find((e) => e.id === 26)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">{client.email}</td>
      )}
      {activeCols.find((e) => e.id === 27)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.telefono && <span>{client?.telefono}</span>}
        </td>
      )}
      {activeCols.find((e) => e.id === 28)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
          {client?.fechaCumpleanios &&
            format(new Date(client.fechaCumpleanios), "dd MMMM, yyyy", {
              locale: es,
            })}
        </td>
      )}
      {activeCols.find((e) => e.id === 29)?.show && (
        <td className="px-6 py-4 max-w-xs truncate border border-gray-300">
          {client?.puestoTrabajo && (
            <span className=" capitalize">{client?.puestoTrabajo}</span>
          )}
        </td>
      )}
    </tr>
  );
};

export default ItemRowAfiliacionClientes;
